module.exports = __webpack_public_path__ + "static/media/Roamhome.28a515f7.svg";